// extracted by mini-css-extract-plugin
module.exports = {"scroll":"selections_scroll__UvCtB","container":"selections_container__ZjYLk","card":"selections_card__k2u_a","image":"selections_image__Nc52P"};